import {useEffect} from 'react';
import {getWebDownloadPosterTypeNames} from '@Libraries/poster-download-library';
import {useAppDispatch, useAppSelector} from '@/hooks';
import {updateWebDownloadPosterTypeNames} from '@Components/download-panel/download-panel.reducer';

export const useGetWebDownloadPosterTypes = (): void => {
  const posterTypeNames = useAppSelector((state) => {
    return state.downloadDialog.webDownloadPosterTypeNames;
  });
  const dispatch = useAppDispatch();
  const getAndStoreData = async (): Promise<void> => {
    if (posterTypeNames && posterTypeNames.length > 0) {
      return;
    }
    const data = await getWebDownloadPosterTypeNames();
    dispatch(updateWebDownloadPosterTypeNames(data));
  };

  useEffect(() => {
    void getAndStoreData();
  }, []);
};
